import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M20 40c6.563 0 12.387-3.16 16.033-8.043H3.966C7.613 36.84 13.437 40 20 40Zm20-20C40 8.954 31.046 0 20 0S0 8.954 0 20c0 2.365.412 4.634 1.165 6.74h37.67A19.96 19.96 0 0 0 40 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "m13.69 12.827 1.078 3.321h3.493l-2.825 2.053 1.079 3.321-2.826-2.052-2.825 2.052 1.08-3.321-2.826-2.053h3.492l1.08-3.321ZM7.692 9.348l.647 1.993h2.096L8.74 12.573l.647 1.993-1.695-1.232-1.696 1.232.648-1.993-1.695-1.232h2.095l.648-1.993Z"
}, null, -1), h = [
  n,
  c,
  s
];
function r(d, i) {
  return e(), l("svg", o, [...h]);
}
const a = { render: r };
export {
  a as default,
  r as render
};
